"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TokenValidator = _interopRequireDefault(require("../../../core/TokenValidator"));

var _FetchHelper = _interopRequireDefault(require("../../../core/FetchHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MTKService =
/*#__PURE__*/
function () {
  function MTKService(url, kundennummer, obtainTokenMethod, removeTokenMethod, tokenMethod, trainingCenterId) {
    _classCallCheck(this, MTKService);

    this.url = url;
    this.kundennummer = kundennummer;
    this.obtainTokenMethod = obtainTokenMethod;
    this.removeTokenMethod = removeTokenMethod;
    this.trainingCenterId = trainingCenterId;
  }

  _createClass(MTKService, [{
    key: "getCompaniesOfTK",
    value: function getCompaniesOfTK() {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/mtk/companies", options);
    }
  }, {
    key: "getPersonalOfCompany",
    value: function getPersonalOfCompany(companyId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/mtk/users/" + (companyId ? companyId : -1), options);
    }
  }, {
    key: "getUserDetailOfPersonal",
    value: function getUserDetailOfPersonal(userId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/mtk/user/" + userId, options);
    }
  }, {
    key: "book",
    value: function book(request) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        },
        body: JSON.stringify(request)
      };
      return _FetchHelper["default"].post(this.url + "/mtk/booking/", options);
    }
  }, {
    key: "cancel",
    value: function cancel(type, meetingId, userId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/mtk/booking/" + type + "/" + meetingId + "/user/" + userId, options);
    }
  }, {
    key: "decline",
    value: function decline(meetingId, userId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/mtk/booking/decline/" + meetingId + "/user/" + userId, options);
    }
  }, {
    key: "getBookingsOfCompanyUsers",
    value: function getBookingsOfCompanyUsers() {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/mtk/booking/", options);
    } //LB customizing

  }, {
    key: "getCompanyStatistics",
    value: function getCompanyStatistics(companyId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/mtk/statistic/company/".concat(companyId ? companyId : -1), options);
    }
  }, {
    key: "getCompanyBonusPoints",
    value: function getCompanyBonusPoints(companyId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/mtk/statistic/company/".concat(companyId ? companyId : -1, "/bonus-points"), options);
    }
  }]);

  return MTKService;
}();

exports["default"] = MTKService;